export const textShadow = "text-shadow: 1px 1px 0 black";
export const boxShadowSmall = "box-shadow: 1px 1px 0 black";
export const boxShadowLarge = "box-shadow: 4px 4px 10px black";
